var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActiveCheckbox = function SvgActiveCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 25.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3642",
    transform: "translate(-553.197 -581.197)",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 146",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(553.947 581.947)",
    fill: "#e81e61",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18764",
    d: "m561.731 594.124 2.53 2.494 5.9-6.256",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};
export default SvgActiveCheckbox;